import { render, staticRenderFns } from "./ClassifiedsList.vue?vue&type=template&id=65b9a6e9&"
import script from "./ClassifiedsList.vue?vue&type=script&lang=js&"
export * from "./ClassifiedsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports